var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.isShow},on:{"click":function($event){_vm.isShow = false}}},[_c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_c('span',{staticStyle:{"color":"#fff"}},[_vm._v(_vm._s(_vm.title || "加载中···"))])])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }